/* Memoria – reviewpagina (sections/mj-all-reviews.liquid).
   Haalt alle reviews op via Judge.me's openbare endpoint (25 per pagina, parallel) en
   toont ze in eigen opmaak; filteren en sorteren gebeurt daarna in de browser. */
(function () {
  var root = document.querySelector('[data-mj-ar]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var API = 'https://cdn.judge.me/reviews/all_reviews_js_based';
  var PER_PAGE = 25;
  var SHOW_STEP = 10;
  var list = root.querySelector('[data-mj-ar-list]');
  var status = root.querySelector('[data-mj-ar-status]');
  var more = root.querySelector('[data-mj-ar-more]');
  var sel = {
    type: root.querySelector('[data-mj-ar-filter="type"]'),
    product: root.querySelector('[data-mj-ar-filter="product"]'),
    sort: root.querySelector('[data-mj-ar-filter="sort"]')
  };
  /* Taal: Engels op /en/, anders Nederlands */
  var EN = (root.dataset.mjLang || document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    anon: 'Anonymous', locale: 'en-GB', shop: 'About Memoria', none: 'No reviews match these filters.',
    view: 'View photo from ', photo: 'Photo shared by ', of5: ' out of 5 stars', verified: 'Verified buyer',
    fail: 'Reviews could not be loaded. Please refresh the page.'
  } : {
    anon: 'Anoniem', locale: 'nl-NL', shop: 'Over Memoria', none: 'Er zijn geen ervaringen die bij deze filters passen.',
    view: 'Bekijk de foto van ', photo: 'Foto van ', of5: ' van 5 sterren', verified: 'Geverifieerde koper',
    fail: 'De ervaringen konden niet worden geladen. Ververs de pagina en probeer het opnieuw.'
  };
  /* Productlinks op /en/ met het /en/-voorvoegsel */
  function localUrl(u) {
    if (!EN || !u) return u;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/en/';
    var m = String(u).match(/^(?:https?:\/\/[^\/]+)?\/(products\/.*)$/);
    return m ? base + m[1] : u;
  }
  var all = [];
  var view = [];
  var shown = 0;

  var starPath = 'M12 2.8l2.8 5.9 6.4.8-4.7 4.5 1.2 6.4L12 17.3l-5.7 3.1 1.2-6.4L2.8 9.5l6.4-.8z';
  function stars(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<svg class="mj-pr__star' + (n >= i ? '' : ' mj-pr__star--off') + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + starPath + '"/></svg>';
    return h;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function displayName(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return T.anon;
    var first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
    return parts.length > 1 ? first + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.' : first;
  }
  function shortProduct(title) { return String(title || '').split('|')[0].trim(); }
  function formatDate(d) {
    return isNaN(d) ? '' : d.toLocaleDateString(T.locale, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  /* Judge.me levert HTML; die lezen we inert uit (DOMParser voert niets uit) en houden alleen tekst/URL's over */
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (el) {
      var q = function (s) { return el.querySelector(s); };
      var link = q('.jdgm-rev__prod-link');
      var ts = q('.jdgm-rev__timestamp');
      var body = q('.jdgm-rev__body');
      var pics = Array.prototype.map.call(el.querySelectorAll('.jdgm-rev__pic-link'), function (a) {
        var big = a.getAttribute('href') || '';
        return { big: big, thumb: big.split('?')[0] + '?quality=80&width=480' };
      });
      return {
        id: el.getAttribute('data-review-id'),
        rating: +(q('.jdgm-rev__rating') || {}).getAttribute('data-score') || 0,
        verified: el.getAttribute('data-verified-buyer') === 'true',
        date: new Date(((ts && ts.getAttribute('data-content')) || '').replace(' UTC', 'Z').replace(' ', 'T')),
        author: displayName((q('.jdgm-rev__author') || {}).textContent),
        title: ((q('.jdgm-rev__title') || {}).textContent || '').trim(),
        body: body ? (Array.prototype.map.call(body.querySelectorAll('p'), function (x) { return x.textContent.trim(); }).filter(Boolean).join('\n') || body.textContent) : '',
        product: link ? shortProduct(link.textContent) : '',
        productUrl: link ? link.getAttribute('href') : '',
        pics: []
      };
    }).filter(function (r) { return !/melk|borstvoed|mama ?jewels|baby/i.test(r.title + ' ' + r.body); });
  }

  function fetchPage(page) {
    var url = API + '?shop_domain=' + encodeURIComponent(root.dataset.shop) + '&platform=shopify&review_type=all-reviews' +
      '&sort_by=most-recent&per_page=' + PER_PAGE + '&page=' + page;
    return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { return parse(d.html || ''); });
  }

  function load() {
    var pages = Math.max(1, Math.ceil((+root.dataset.count || PER_PAGE) / PER_PAGE));
    var jobs = [];
    for (var p = 1; p <= pages; p++) jobs.push(fetchPage(p).catch(function () { return []; }));
    return Promise.all(jobs).then(function (chunks) {
      var seen = {};
      chunks.forEach(function (c) { c.forEach(function (r) { if (!seen[r.id]) { seen[r.id] = 1; all.push(r); } }); });
      all.forEach(function (r) { if (/^memoria( jewelry)?$/i.test(r.product)) r.product = ''; });
      buildProducts();
      updateHistogram();
      apply();
    });
  }

  function buildProducts() {
    var counts = {};
    all.forEach(function (r) { if (r.product) counts[r.product] = (counts[r.product] || 0) + 1; });
    Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b, EN ? 'en' : 'nl'); }).forEach(function (name) {
      var o = document.createElement('option');
      o.value = name; o.textContent = name + ' (' + counts[name] + ')';
      sel.product.appendChild(o);
    });
    if (all.some(function (r) { return !r.product; })) {
      var o = document.createElement('option');
      o.value = '__shop'; o.textContent = T.shop;
      sel.product.appendChild(o);
    }
  }

  /* Verdeling per ster opnieuw uit de geladen reviews (klopt altijd met de lijst) */
  function updateHistogram() {
    if (!all.length) return;
    root.querySelectorAll('[data-mj-ar-rating]').forEach(function (b) {
      var n = all.filter(function (r) { return r.rating === +b.dataset.mjArRating; }).length;
      var pct = Math.round(n * 100 / all.length);
      var bar = b.querySelector('[data-mj-ar-bar]'), num = b.querySelector('[data-mj-ar-num]');
      if (bar) bar.style.width = pct + '%';
      if (num) num.textContent = pct + '% (' + n + ')';
    });
  }

  function apply() {
    var type = sel.type.value, product = sel.product.value, sort = sel.sort.value;
    view = all.filter(function (r) {
      if (type === 'photos' && !r.pics.length) return false;
      if (/^[1-5]$/.test(type) && r.rating !== +type) return false;
      if (product === '__shop' && r.product) return false;
      if (product !== 'all' && product !== '__shop' && r.product !== product) return false;
      return true;
    });
    view.sort(function (a, b) {
      if (sort === 'high' && b.rating !== a.rating) return b.rating - a.rating;
      if (sort === 'low' && b.rating !== a.rating) return a.rating - b.rating;
      if (sort === 'photos' && !!b.pics.length !== !!a.pics.length) return b.pics.length ? 1 : -1;
      return b.date - a.date;
    });
    shown = 0;
    list.innerHTML = '';
    status.textContent = view.length ? view.length + ' ' + (view.length === 1 ? 'review' : 'reviews') : T.none;
    root.querySelectorAll('[data-mj-ar-rating]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.mjArRating === type); });
    showMore();
  }

  function showMore() {
    var html = view.slice(shown, shown + SHOW_STEP).map(render).join('');
    list.insertAdjacentHTML('beforeend', html);
    shown = Math.min(view.length, shown + SHOW_STEP);
    more.hidden = shown >= view.length;
  }

  function render(r) {
    var pics = r.pics.slice(0, 2);
    var media = pics.length ? '<div class="mj-ar__media mj-ar__media--' + pics.length + '">' + pics.map(function (p) {
      return '<button type="button" class="mj-ar__media-btn" data-mj-ar-zoom="' + esc(p.big) + '" aria-label="' + T.view + esc(r.author) + '"><img src="' + esc(p.thumb) + '" alt="' + T.photo + esc(r.author) + '" loading="lazy" width="480" height="340"></button>';
    }).join('') + '</div>' : '';
    var product = r.product ? '<span class="mj-ar__sep" aria-hidden="true"></span>' + (r.productUrl ? '<a href="' + esc(localUrl(r.productUrl)) + '">' + esc(r.product) + '</a>' : esc(r.product)) : '';
    return '<li class="mj-ar__item' + (media ? '' : ' mj-ar__item--text') + '">' + media +
      '<div class="mj-ar__content">' +
        '<div class="mj-ar__top"><span class="mj-ar__stars mj-ar__stars--gold" role="img" aria-label="' + r.rating + T.of5 + '">' + stars(r.rating) + '</span>' +
        (r.verified ? '<span class="mj-ar__verified"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8"/><path d="M4.6 8.3l2.2 2.2 4.6-4.8"/></svg>' + T.verified + '</span>' : '') +
        '<span class="mj-ar__date">' + esc(formatDate(r.date)) + '</span></div>' +
        (r.title ? '<h3 class="mj-ar__item-title">' + esc(r.title) + '</h3>' : '') +
        '<p class="mj-ar__body">' + esc(r.body.trim()) + '</p>' +
        '<p class="mj-ar__who"><span>' + esc(r.author) + '</span>' + product + '</p>' +
      '</div></li>';
  }

  /* Filters */
  Object.keys(sel).forEach(function (k) { sel[k].addEventListener('change', apply); });
  more.addEventListener('click', showMore);
  root.querySelectorAll('[data-mj-ar-rating]').forEach(function (b) {
    b.addEventListener('click', function () {
      sel.type.value = sel.type.value === b.dataset.mjArRating ? 'all' : b.dataset.mjArRating;
      apply();
      root.querySelector('.mj-ar__filters').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Fotostrook: pijltjes, vegen (native) en slepen met de muis */
  (function () {
    var strip = root.querySelector('[data-mj-ar-strip]');
    if (!strip) return;
    var prev = root.querySelector('[data-mj-ar-prev]');
    var next = root.querySelector('[data-mj-ar-next]');
    var step = function () { return Math.max(strip.clientWidth * 0.8, 200); };
    var update = function () {
      var max = strip.scrollWidth - strip.clientWidth - 2;
      prev.hidden = strip.scrollLeft <= 2;
      next.hidden = strip.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    var down = false, moved = false, startX = 0, startLeft = 0;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = strip.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; strip.classList.add('is-dragging'); }
      if (moved) strip.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) setTimeout(function () { strip.classList.remove('is-dragging'); }, 0);
    });
  })();

  /* Fotovenster */
  var zoom = root.querySelector('[data-mj-ar-zoombox]');
  var zoomImg = root.querySelector('[data-mj-ar-zoomimg]');
  root.addEventListener('click', function (e) {
    var z = e.target.closest('[data-mj-ar-zoom]');
    if (z) { zoomImg.src = z.dataset.mjArZoom; zoom.showModal(); return; }
    if (e.target.closest('[data-mj-ar-close]')) e.target.closest('dialog').close();
  });
  root.querySelectorAll('dialog').forEach(function (d) { d.addEventListener('click', function (e) { if (e.target === d) d.close(); }); });

  /* Schrijven: Judge.me's formulier in een venster */
  var formBox = root.querySelector('[data-mj-ar-formbox]');
  root.querySelector('[data-mj-ar-write]').addEventListener('click', function () {
    formBox.showModal();
    var link = formBox.querySelector('.jdgm-write-rev-link');
    var wrap = formBox.querySelector('.jdgm-form-wrapper');
    if (wrap && getComputedStyle(wrap).display === 'none' && link) link.click();
    formBox.classList.add('is-writing');
  });

  load().catch(function () { status.textContent = T.fail; });
})();
